import { client } from '@/libs/openApi'
import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'

import { CrossSellingParams } from '../types'

export const getCrossSellingHotels = async (params: CrossSellingParams) => {
	const { language } = useAppConfigStore.getState()

	const { data } = await client.POST('/ibe/v3/crossselling', {
		body: { ...params, language },
	})

	return data
}
